const HeroBanner = () => {
  const awsImageBaseUrl = process.env.REACT_APP_AWS_IMAGE_BUCKET_URL; 
  return (
 <section>
      <div className="card text-white border-0 hero-card ">
        {/* Responsive image wrapper with fixed height */}
        <div className="card-img-wrapper">
          <img src={`${awsImageBaseUrl}images/WhatWeDo/WhatWeDo.png`}  className="card-img rounded-0" alt="Hero Background" />
        </div>
        {/* Overlay Content */}
        <div className="card-img-overlay d-flex flex-column justify-content-center align-items-center text-center hero-overlay">
          <h1 className="font-bold  display-5 mb-4 text-shadow text-uppercase">
          <span className="red-bottom-border">What We Do</span>
          </h1>

        </div>

  </div>  
  </section>
  );
};

export default HeroBanner;